function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useMemo, useRef, useState } from 'react';
import throttle from 'lodash.throttle';
import GoldenLayout from '@deephaven/golden-layout';
import { useResizeObserver } from '@deephaven/react-hooks';
import "./layout/GoldenLayout.css";
import LayoutUtils from "./layout/LayoutUtils.js";
import PanelPlaceholder from "./PanelPlaceholder.js";
import DashboardLayout from "./DashboardLayout.js";
import "./Dashboard.css";
import { LayoutManagerContext } from "./layout/index.js";
import { DashboardIdContext } from "./useDashboardId.js";
import { FiberProvider } from "./useFiber.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RESIZE_THROTTLE = 100;
var DEFAULT_CALLBACK = () => undefined;
var EMPTY_OBJECT = Object.freeze({});
export function Dashboard(_ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'default' : _ref$id,
    children = _ref.children,
    emptyDashboard = _ref.emptyDashboard,
    layoutConfig = _ref.layoutConfig,
    _ref$layoutSettings = _ref.layoutSettings,
    layoutSettings = _ref$layoutSettings === void 0 ? EMPTY_OBJECT : _ref$layoutSettings,
    _ref$onLayoutConfigCh = _ref.onLayoutConfigChange,
    onLayoutConfigChange = _ref$onLayoutConfigCh === void 0 ? DEFAULT_CALLBACK : _ref$onLayoutConfigCh,
    _ref$onGoldenLayoutCh = _ref.onGoldenLayoutChange,
    onGoldenLayoutChange = _ref$onGoldenLayoutCh === void 0 ? DEFAULT_CALLBACK : _ref$onGoldenLayoutCh,
    _ref$onLayoutInitiali = _ref.onLayoutInitialized,
    onLayoutInitialized = _ref$onLayoutInitiali === void 0 ? DEFAULT_CALLBACK : _ref$onLayoutInitiali,
    _ref$fallbackComponen = _ref.fallbackComponent,
    fallbackComponent = _ref$fallbackComponen === void 0 ? PanelPlaceholder : _ref$fallbackComponen,
    hydrate = _ref.hydrate,
    dehydrate = _ref.dehydrate,
    panelWrapper = _ref.panelWrapper;
  var layoutElement = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInitialized = _useState2[0],
    setIsInitialized = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    layout = _useState4[0],
    setLayout = _useState4[1];
  useEffect(function initDashboard() {
    if (!layoutElement.current) {
      setLayout(undefined);
      return;
    }
    var config = _objectSpread({}, LayoutUtils.makeDefaultLayout());
    if (config.settings === undefined) {
      config.settings = {};
    }
    Object.assign(config.settings, layoutSettings);

    // Load our content later after plugins have registered
    config.content = [];
    var newLayout = new GoldenLayout(config, layoutElement.current);
    var onInit = () => {
      newLayout.off('initialised', onInit);
      setIsInitialized(true);
    };
    newLayout.on('initialised', onInit);
    if (fallbackComponent != null) {
      newLayout.setFallbackComponent(fallbackComponent);
    }
    newLayout.init();
    setLayout(newLayout);
    onGoldenLayoutChange(newLayout);
    return () => {
      newLayout.destroy();
    };
  }, [layoutSettings, fallbackComponent, onGoldenLayoutChange, setIsInitialized, setLayout]);
  var handleResize = useMemo(() => throttle(() => {
    if (layout != null && layout.isInitialised) {
      layout === null || layout === void 0 || layout.updateSize();
    }
  }, RESIZE_THROTTLE), [layout]);
  useResizeObserver(layoutElement.current, handleResize);
  return /*#__PURE__*/_jsxs("div", {
    className: "dashboard-container w-100 h-100",
    children: [/*#__PURE__*/_jsx("div", {
      className: "w-100 h-100",
      ref: layoutElement
    }), isInitialized && layout && /*#__PURE__*/_jsx(LayoutManagerContext.Provider, {
      value: layout,
      children: /*#__PURE__*/_jsx(DashboardIdContext.Provider, {
        value: id,
        children: /*#__PURE__*/_jsx(FiberProvider, {
          children: /*#__PURE__*/_jsx(DashboardLayout, {
            emptyDashboard: emptyDashboard,
            id: id,
            layout: layout,
            layoutConfig: layoutConfig,
            onLayoutChange: onLayoutConfigChange,
            onLayoutInitialized: onLayoutInitialized,
            hydrate: hydrate,
            dehydrate: dehydrate,
            panelWrapper: panelWrapper,
            children: children
          })
        })
      })
    })]
  });
}
export default Dashboard;
//# sourceMappingURL=Dashboard.js.map